import moment, { MomentInput } from 'moment';

export const formatDate = (date: MomentInput, format?: string) => date ? moment(date).format(format) : null;

export const formatStringDate = (date: MomentInput) => moment(date).format('YYYY-MM-DD HH:mm');

export const formatStringDateOnly = (date: MomentInput) => moment(date).format('YYYY-MM-DD');

export const formatAmount = (amount: number): string => amount?.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ');
